import EmployeeDataSettings from './EmployeeDataSettings';

export default EmployeeDataSettings;
